(function(angular) {
    'use strict';

    angular.module('wtApp.AbstractModal').controller('GenericModal', genericModal);

    genericModal.$inject = ['$scope', '$modalInstance', 'modalConfig', 'modalHelperService'];

    /**
     * An abstract controller that can be used as a base controller for modal windows.
     */
    function genericModal($scope, $modalInstance, modalConfig, modalHelperService) {
        $scope.modalTitle = modalConfig.title || ' ';

        /**
         * Can be called to close the modal.
         */
        $scope.abortModal = function() {
            $modalInstance.dismiss('cancel');
        };

        /**
         * A generic callback function that can be called by ok, cancel ...
         */
        $scope.buttonAction = function() {
            var response = false;

            if (arguments.length) {
                response = arguments[0];
            }

            $modalInstance.close(response);
        };

        $scope.$on('$destroy', function() {
            $scope.modalTitle = null;
            $scope.abortModal = null;
            $scope.buttonAction = null;
            modalHelperService.resetPadding();
        });
    }
})(window.angular);

